import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { MutationForm } from './form/graphql/MutationForm';
import { useAlert } from './alert/AlertStack';
import { ModalPricesUpdate } from './modal/ModalPricesUpdate';
import { UpdateSaleItemPriceGloballyMutation } from 'graphql/SaleItem/mutations/UpdateSaleItemPriceGloballyMutation';
import { SaleItemsQuery } from 'graphql/SaleItem/queries/SaleItemsQuery';
import './PricesUpdateButton.scss';
/**
 * @component PricesUpdateButton
 * @since 1.0.0
 * @hidden
 */
export function PricesUpdateButton(props) {
    const { optionConfiguration, picto, label, style } = Object.assign({ style: 'normal', picto: 'pen-to-square' }, props);
    const alert = useAlert();
    const [processing, setProcessing] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    const onClick = () => {
        setOpenModal(true);
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        setOpenModal(false);
    };
    /**
     * @function onModalSubmit
     * @since 1.0.0
     * @hidden
     */
    function onModalSubmit(formValues) {
        const { changeType, percentage } = formValues;
        const input = {
            changeType,
            percentage: Number(percentage) / 100,
            itemType: optionConfiguration
        };
        return {
            variables: {
                input
            },
            refetchQueries: [
                {
                    query: SaleItemsQuery
                }
            ],
            update(cache) {
                cache.evict({ fieldName: 'saleItems' });
            }
        };
    }
    /**
     * @function onSuccess
     * @since 1.0.0
     * @hidden
     */
    function onSuccess(result) {
        alert.present({
            title: React.createElement("p", null, t('Sale items has been updated.'))
        });
    }
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    function onFailure() {
        setProcessing(false);
    }
    const className = classNames('prices-update-button', 'prices-update-button--' + style, { 'prices-update-button--is-processing': processing }, { 'prices-update-button--has-label': label }, { 'prices-update-button--has-picto': picto });
    return (React.createElement("div", null,
        React.createElement("button", { className: className, onClick: onClick },
            picto && React.createElement(Icon, { className: "prices-update-button-picto", value: picto }),
            label && React.createElement(Text, { className: "prices-update-button-label", value: label })),
        openModal && (React.createElement(MutationForm, { name: "prices-update-form", mutation: UpdateSaleItemPriceGloballyMutation, onProcess: onModalSubmit, onSuccess: onSuccess, onFailure: onFailure },
            React.createElement(ModalPricesUpdate, { onClose: onClose, processing: processing })))));
}
